import { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import useConditions from "../conditions/useConditions";

const useEmbedRecommendations = () => {
  const [contextData, builder] = useContext(VariantContextData);
  const { Conditions } = useConditions();

  let variant = contextData.objects.variant;

  const EmbedRecommendations = {
    create: async function (element, payload, options) {
      builder.create(
        "embed_recommendations",
        {
          ...(payload || {}),
          element_id: element ? element.id : undefined,
        },
        {
          transform: function (embed_recommendation) {
            embed_recommendation.open = true;
            return embed_recommendation;
          },
          callback: options ? options.callback : undefined,
        }
      );
    },

    duplicate: async function (og_embed_recommendation, payload, skip_history) {
      let attributes = {
        options: og_embed_recommendation.options,
      };

      if (payload) {
        attributes = { ...attributes, ...payload };
      }

      builder.create("embed_recommendations", attributes, {
        callback: async function (embed_recommendation) {
          let conditions = Object.values(variant.conditions).filter(
            (condition) =>
              condition.contactable_type == "EmbedRecommendation" &&
              condition.contactable_id == og_embed_recommendation.id &&
              condition.toBeDeleted !== true
          );

          conditions.forEach((condition) => {
            Conditions.duplicate(
              condition,
              {
                contactable_id: embed_recommendation.id,
              },
              true
            );
          });
        },
        skip_history: skip_history,
        skip_select: true,
      });
    },

    remove: (embed_recommendation) => {
      let message =
        "Are you sure you want to remove this embed recommendation? Once your changes are saved, it will be irreversibly deleted.";

      builder.remove("embed_recommendations", embed_recommendation.id, message);
    },
  };

  let currentHook = EmbedRecommendations;
  return { EmbedRecommendations, currentHook };
};

export default useEmbedRecommendations;
